import React from "react";
import { STATUSES } from "./cityStats";
import CityDialogue from "./CityDialogue";

function Chip({ label, value, testid }) {
  return (
    <div className="border border-cyan-400/30 bg-cyan-400/5 px-2.5 py-1.5" data-testid={testid}>
      <p className="cq-px text-[6px] sm:text-[7px] text-slate-400 uppercase">{label}</p>
      <p className="cq-px text-[8px] sm:text-[10px] text-amber-300 mt-1">{value}</p>
    </div>
  );
}

function PersonalStats({ b, stats }) {
  const stage = stats.stageIndex;
  return (
    <div className="mb-3" data-testid="city-panel-personal">
      <p className="cq-px text-[7px] text-cyan-300 mb-2">▸ YOUR FILE · {stats.name?.toUpperCase()}</p>
      <div className="flex flex-wrap gap-2">
        {b.id === "clinic" && (
          <>
            <Chip label="Stage" value={`${(stage ?? 0) + 1}/${STATUSES.length} · ${stats.status || "—"}`} testid="city-stat-stage" />
            <div className="flex-1 min-w-[160px] flex items-end gap-1 pb-1" aria-label="progress">
              {STATUSES.map((s, i) => <span key={s} className={`h-2 flex-1 ${i <= (stage ?? -1) ? "bg-amber-400" : "bg-slate-700"}`} />)}
            </div>
          </>
        )}
        {b.id === "bank" && (
          <>
            <Chip label="FundingIQ" value={stats.fundingiq != null ? `${stats.fundingiq} / 1000` : "—"} testid="city-stat-iq" />
            <Chip label="Available today" value={stats.availableToday != null ? `$${Number(stats.availableToday).toLocaleString()}` : "—"} testid="city-stat-avail" />
            <Chip label="Readiness" value={stats.readiness != null ? `${stats.readiness}/100` : "—"} />
          </>
        )}
        {b.id === "cafe" && (
          <>
            <Chip label="Upcoming" value={stats.upcomingMeetings ?? 0} testid="city-stat-meetings" />
            {stats.nextMeeting && <Chip label="Next" value={new Date(stats.nextMeeting).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })} />}
          </>
        )}
        {b.id === "post" && <Chip label="Messages" value={stats.messageCount ?? 0} testid="city-stat-messages" />}
        {b.id === "tradelines" && <Chip label="Reservations" value={stats.reservations ?? 0} />}
        {b.id === "hall" && <Chip label="Specialist" value={stats.specialist || "Unassigned"} />}
        {!["clinic", "bank", "cafe", "post", "tradelines", "hall"].includes(b.id) && <Chip label="Status" value={stats.status || "—"} />}
      </div>
      {b.id === "clinic" && stats.nextStep && <p className="font-mono text-[12px] text-slate-300 mt-2 leading-relaxed">Next: {stats.nextStep}</p>}
      {b.id === "post" && stats.lastMessage && <p className="font-mono text-[12px] text-slate-300 mt-2 truncate">Last · {stats.lastMessage}</p>}
    </div>
  );
}

export default function CityPanel({ building, stats, user, onClose, onGo }) {
  if (!building) return null;
  const b = building;
  const isClient = user?.role === "client";
  const isStaff = user && !isClient;
  const primaryLabel = !user ? b.publicCta : isStaff && b.action !== "arcade" ? "Open Admin Dashboard" : b.cta;
  const text = `${b.tagline}\n${b.lines.join(" ")}`;

  return (
    <CityDialogue title={`${b.name.toUpperCase()}`} text={text} onClose={onClose} testid={`city-panel-${b.id}`}>
      {isClient && stats && <PersonalStats b={b} stats={stats} />}
      <div className="flex flex-wrap items-center gap-2">
        <button onClick={() => onGo(b, "primary")} className="cq-px text-[8px] sm:text-[10px] bg-cyan-400 text-slate-950 px-4 py-2.5 hover:bg-cyan-300 active:translate-y-px" data-testid="city-panel-cta">
          {primaryLabel.toUpperCase()}
        </button>
        {b.secondary && isClient && (
          <button onClick={() => onGo(b, "secondary")} className="cq-px text-[8px] sm:text-[10px] border border-amber-400 text-amber-300 px-4 py-2.5 hover:bg-amber-400/10" data-testid="city-panel-secondary">
            {b.secondary.label.toUpperCase()}
          </button>
        )}
        <button onClick={onClose} className="cq-px text-[8px] sm:text-[10px] border border-violet-400/60 text-violet-200 px-4 py-2.5 hover:bg-violet-400/10" data-testid="city-panel-back">KEEP WALKING</button>
        {!user && <span className="cq-px text-[6px] sm:text-[7px] text-slate-500 ml-auto">Free account · no card needed · you keep the duck</span>}
      </div>
    </CityDialogue>
  );
}
